import { BasicsClass } from '@/common/BasicsClass';
import { Util } from '@/common/util';

export default class ShopPopupNoticeAPI extends BasicsClass {
    public apiUrls: any = new Map([
        ['list', {
            url: '/admin/shopNotice/index',
            name: 'list',
            label: '通知列表'
        }],
        ['add',  {
            url: '/admin/shopNotice/add',
            name: 'add',
            label: '添加通知'
        }],

        ['edit',  {
            url: '/admin/shopNotice/edit',
            name: 'edit',
            label: '编辑通知'
        }],
        ['delete',  {
            url: '/admin/shopNotice/del',
            name: 'delete',
            label: '删除通知'
        }],
        ['push',  {
            url: '/admin/shopNotice/push',
            name: 'push',
            label: '发布通知'
        }],
        ['confine',  {
            url: '/admin/shopNotice/confine',
            name: 'confine',
            label: '通知屏蔽店铺列表'
        }],
        ['confineAdd',  {
            url: '/admin/shopNotice/confineAdd',
            name: 'confineAdd',
            label: '通知屏蔽店铺添加'
        }],
        ['confineDel',  {
            url: '/admin/shopNotice/confineDel',
            name: 'confineDel',
            label: '通知屏蔽店铺删除'
        }],
        ['searchVenueList', {
            url: '/admin/coupons/shop/list',
            name: 'shop-list',
            label: '店铺列表',
        }],
    ])
    public list(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
        const apiUrls = this.apiUrls

        const url = apiUrls.get('list').url

        this.BasicPost(url, {
            ...params
        }, false, false, false, successCb, failCb, showLoading)
    }

    public add(params: any, successCb?: Function, failCb?: Function, showLoading: boolean = false) {
        const apiUrls = this.apiUrls

        const url = apiUrls.get('add').url

        return new Promise((resolve, reject) => {
            this.BasicPost(url, {
                ...params
            }, false, false, false, (res: any) => {
                typeof successCb == 'function' && successCb(res);
                resolve(res);
            }, (err: any) => {
                typeof failCb == 'function' && failCb(err)
                reject(err)
            }, showLoading)
        })

    }

    public edit(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
        const apiUrls = this.apiUrls

        const url = apiUrls.get('edit').url

        this.BasicPost(url, {
            ...params
        }, false, false, false, successCb, failCb, showLoading)
    }

    public delete(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
        const apiUrls = this.apiUrls

        const url = apiUrls.get('delete').url

        this.BasicPost(url, {
            ...params
        }, false, false, false, successCb, failCb, showLoading)
    }

    public push(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
        const apiUrls = this.apiUrls

        const url = apiUrls.get('push').url

        this.BasicPost(url, {
            ...params
        }, false, false, false, successCb, failCb, showLoading)
    }

    public confine(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
        const apiUrls = this.apiUrls

        const url = apiUrls.get('confine').url

        this.BasicPost(url, {
            ...params
        }, false, false, false, successCb, failCb, showLoading)
    }

    public confineAdd(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
        const apiUrls = this.apiUrls

        const url = apiUrls.get('confineAdd').url

        this.BasicPost(url, {
            ...params
        }, false, false, false, successCb, failCb, showLoading)
    }

    public confineDel(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
        const apiUrls = this.apiUrls

        const url = apiUrls.get('confineDel').url

        this.BasicPost(url, {
            ...params
        }, false, false, false, successCb, failCb, showLoading)
    }

    public searchVenueList(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
        const apiUrls = this.apiUrls

        const url = apiUrls.get('searchVenueList').url

        this.BasicPost(url, {
            ...params
        }, false, false, false, successCb, failCb, showLoading)
    }

  }
